module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio41-1b14f19317989edcc91dcf115c6d7f72.m4a";